module.exports = __webpack_public_path__ + "img/horizontal_7_2_9005.49b23954.png";